import axios from 'axios';
import { createAsyncThunk, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';
import { cleanEntity } from 'app/shared/util/entity-utils';
import { IQueryParams, createEntitySlice, EntityState, serializeAxiosError } from 'app/shared/reducers/reducer.utils';
import { defaultTransaction, ITransaction } from 'app/shared/model/transaction.model';

const initialState: EntityState<ITransaction> = {
  loading: false,
  errorMessage: null,
  entities: [],
  entity: defaultTransaction,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};

const apiUrl = 'api/transactions';

// Actions

export const getEcoleComptesTransactions = createAsyncThunk('transaction/fetch_entity_list', async (entity: any) => {
  const { ecoleId, page, size, type, startDate, endDate, description, moyenPaiement } = entity;

  let searchUrl = '';

  if (type) {
    searchUrl += `&type=${encodeURIComponent(type)}`;
  }
  if (startDate) {
    searchUrl += `&startDate=${encodeURIComponent(startDate)}`;
  }
  if (endDate) {
    searchUrl += `&endDate=${encodeURIComponent(endDate)}`;
  }
  if (description) {
    searchUrl += `&description=${encodeURIComponent(description)}`;
  }
  if (moyenPaiement) {
    searchUrl += `&moyenPaiement=${encodeURIComponent(moyenPaiement)}`;
  }

  const requestUrl = `${apiUrl}?ecoleId=${encodeURIComponent(ecoleId)}&page=${page}&size=${size}${searchUrl}`;
  return axios.get<ITransaction[]>(requestUrl);
});

// slice

export const transactionSlice = createEntitySlice({
  name: 'transaction',
  initialState,
  extraReducers(builder) {
    builder
      .addMatcher(isFulfilled(getEcoleComptesTransactions), (state, action) => {
        return {
          ...state,
          loading: false,
          entities: action.payload.data,
          totalItems: parseInt(action.payload.headers['x-total-count'], 10),
        };
      })
      .addMatcher(isPending(getEcoleComptesTransactions), state => {
        state.errorMessage = null;
        state.updateSuccess = false;
        state.loading = true;
      });
  },
});

export const { reset } = transactionSlice.actions;

// Reducer
export default transactionSlice.reducer;
